export default __webpack_public_path__ + "static/media/BlockHop_2017-06-26_23-28-15.76fa4d7a.png";